import { SearchIcon } from "lucide-react";
import { cn } from "@tellescope/utils";
import { InputProps } from "./input";

export interface SearchInputProps extends Omit<InputProps, "size"> {
  wrapperClassName?: string;
}

export const SearchInput = ({ className, wrapperClassName, ...props }: SearchInputProps) => {
  return (
    <div className={cn("flex h-9 items-center gap-2 border rounded-sm px-3", wrapperClassName)}>
      <SearchIcon className="size-4 shrink-0 opacity-50" />
      <input className={cn("text-sm grow", className)} {...props} />
    </div>
  );
};
